import React, { Component } from "react";
import styles from "./VideoViewer.module.css";
import styled from "styled-components";
import Popup from "../Dialog/Popup";
const PopupDiv = styled.div`
  background-color: ${(props) => props.theme.panelColour};
  border-radius: 4px;
  width: 200px;
  box-shadow: 0px 4px 12px -20px rgba(0, 0, 0, 0.2),
    0px 8px 20px 2px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12);
  font-size: 0.8em;
  overflow: hidden;
`;
const PopupItem = styled.div`
  padding: 0.5em;
  :hover {
    background-color: #d11e42;
  }
  /* border-bottom: 1px solid grey; */
`;
const PopupGroup = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid black;
`;

export default class VideoViewer extends Component {
  constructor(props) {
    super(props);
    this.userid = localStorage.getItem("user-id");

    this.state = {
      videos: [],
      showDeleteVideoPopup: false,
      videoContextMenuItem: {
        showContext: false,
      },
    };
  }

  componentDidMount() {
    this.getVideos();
  }

  getVideos() {
    let path_id = this.props.project?.use_project_folder
      ? this.props.project?._id
      : this.props.project?.user._id;
    let prefix = this.props.project?.use_project_folder ? "project/" : "";

    fetch(`${window.projectServerURL}assets/videos/${prefix}${path_id}`)
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          videos: data.map((video) => video.name),
        });
      });
  }

  upload(e) {
    const files = Array.from(e.target.files);

    const formData = new FormData();

    files.forEach((file, i) => {
      formData.append("file", file);
    });

    let path_id = this.props.project?.use_project_folder
      ? this.props.project?._id
      : this.props.project?.user._id;
    let prefix = this.props.project?.use_project_folder ? "project/" : "";

    fetch(`${window.projectServerURL}assets/videos/${prefix}${path_id}`, {
      method: "POST",
      body: formData,
    }).then((data) => {
      this.getVideos();
    });
  }

  deleteVideo() {
    let user = localStorage.getItem("user-id");
    let id = this.props.project?.use_project_folder
      ? this.props.project._id
      : user;
    let prefix = this.props.project?.use_project_folder ? "project/" : "";

    fetch(
      `${
        window.projectServerURL
      }assets/videos/${prefix}${id}/${window.encodeURIComponent(
        this.state.videoContextMenuItem.item.replace(/ /g, "_")
      )}`,
      {
        method: "DELETE",
      }
    )
      .then((response) => {
        this.getVideos();
      })
      .finally(() => {
        this.setState({
          ...this.state,
          showDeleteVideoPopup: false,
          videoContextMenuItem: {
            showContext: false,
          },
        });
      });
  }

  handleVideoContextMenu(e, item) {
    this.setState({
      ...this.state,
      videoContextMenuItem: {
        item: item,
        mouseX: e.clientX,
        mouseY: e.clientY,
        showContext: true,
      },
    });
    e.preventDefault();
    this.click = () => this.handleClick();
    window.addEventListener("click", this.click);
  }

  handleClick() {
    this.setState({
      ...this.state,
      videoContextMenuItem: {
        ...this.state.videoContextMenuItem,
        showContext: false,
      },
    });
    window.removeEventListener("click", this.click);
  }

  render() {
    return (
      <div className={styles.ImageViewer}>
        <div
          className={styles.AddContainer}
          onClick={() => document.getElementById("video-input").click()}
        >
          +
        </div>
        <input
          id="video-input"
          type="file"
          name="video"
          accept=".webm"
          style={{ display: "none" }}
          onChange={(e) => {
            this.upload(e);
          }}
        />
        <div className={styles.Images}>
          {this.state.videos.map((video, index) => {
            let path_id = this.props.project?.use_project_folder
              ? this.props.project?._id
              : this.props.project?.user._id;
            let prefix = this.props.project?.use_project_folder
              ? "project/"
              : "";

            return (
              <div
                key={index}
                className={styles.Image}
                onClick={() => {
                  this.props.callback(
                    `${window.projectServerURL}assets/videos/${prefix}${path_id}/${video}`
                  );
                }}
                onContextMenu={(e) => {
                  this.handleVideoContextMenu(e, video);
                }}
              >
                <video
                  src={`${window.projectServerURL}assets/videos/${prefix}${path_id}/${video}`}
                  width="100%"
                  height="auto"
                />
                <div className={styles.Overlay}>{video}</div>
              </div>
            );
          })}
        </div>
        {this.state.showDeleteVideoPopup && (
          <Popup
            title={"Delete Video"}
            message={
              "THIS WILL DELETE THE VIDEO BE CAREFUL IF IT'S USED IN OTHER PAGES!!"
            }
            onSave={() => this.deleteVideo()}
            onCancel={() => {
              this.setState({ ...this.state, showDeleteVideoPopup: false });
            }}
          />
        )}

        {this.state.videoContextMenuItem &&
          this.state.videoContextMenuItem.showContext && (
            <PopupDiv
              style={{
                position: "absolute",
                left: this.state?.videoContextMenuItem?.mouseX + 10,
                top: this.state?.videoContextMenuItem?.mouseY,
                zIndex: 1000,
              }}
            >
              <PopupGroup>
                <PopupItem
                  onClick={() => {
                    this.setState({
                      ...this.state,

                      showDeleteVideoPopup: true,
                    });
                  }}
                >
                  Delete
                </PopupItem>
              </PopupGroup>
            </PopupDiv>
          )}
      </div>
    );
  }
}
